/**
 * User: nir
 * Date: 18/07/2016
 * Time: 14:39
 */
(function () {

    window.TCT = window.TCT || {};
    if (window.TCT.Cookies) return;

    function encode(string, encoded) {
        return encoded && !!window.btoa ? window.btoa(string) : string;
    }

    function decode(encodedString, encoded) {
        try {
            return encoded && !!window.atob ? window.atob(encodedString) : encodedString;
        } catch (error) {
            console.warn('Could not decode cookie value');
            return null;
        }
    }

    function setCookie(cname, cvalue, exdays, encoded) {
        var parts = [
            cname + "=" + encode(cvalue, encoded)
        ];

        if (exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            parts.push("expires=" + d.toUTCString())
        }

        parts.push("path=/");

        document.cookie = parts.join('; '); // cname + "=" + cvalue + "; " + expires + "; " + path;
    }

    function getCookie(cname, encoded) {
        var name = cname + "=",
            ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) == 0) return decode(c.substring(name.length, c.length), encoded);
        }

        return null;
    }

    window.TCT.Cookies = {
        getCookie: getCookie,
        setCookie: setCookie
    };

})();
